import React from 'react';
import PropTypes from 'prop-types';

import { blockShape } from '../../clients/propTypes';
import {
  BLOCK_COMMAND,
  BLOCK_FILE,
  BLOCK_PATHS,
  BLOCK_INSTRUCTIONS,
  BLOCK_NOTE,
  BLOCK_WARNING,
  BLOCK_UNSUPPORTED
} from '../../clients/constants';
import CodeBlock from './components/CodeBlock';
import PathsBlock from './components/PathsBlock';
import InstructionsBlock from './components/InstructionsBlock';
import NoteBlock from './components/NoteBlock';
import UnsupportedBlock from './components/UnsupportedBlock';

const RecipeBlock = ({ block, messageValues = {}, onSelectClient }) => {
  const {
    type,
    titleId,
    textId,
    captionId,
    snippet,
    items,
    ordered,
    alternatives
  } = block;

  switch (type) {
    case BLOCK_COMMAND:
    case BLOCK_FILE:
      return <CodeBlock captionId={ captionId } snippet={ snippet } />;
    case BLOCK_PATHS:
      return <PathsBlock items={ items } />;
    case BLOCK_INSTRUCTIONS:
      return <InstructionsBlock items={ items } messageValues={ messageValues } ordered={ ordered } />;
    case BLOCK_NOTE:
      return <NoteBlock textId={ textId } />;
    case BLOCK_WARNING:
      return <NoteBlock isWarning textId={ textId } titleId={ titleId } />;
    case BLOCK_UNSUPPORTED:
      return (
        <UnsupportedBlock
          alternatives={ alternatives }
          onSelectClient={ onSelectClient }
          textId={ textId }
        />
      );
    default:
      return null;
  }
};

RecipeBlock.propTypes = {
  block: blockShape.isRequired,
  messageValues: PropTypes.objectOf(PropTypes.string),
  onSelectClient: PropTypes.func.isRequired
};

export default RecipeBlock;
